let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lb58d")).then(() => parcelRequire('fZ956'));